export default function ({ ...props }) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 9C13.3137 9 16 7.65685 16 6C16 4.34315 13.3137 3 10 3C6.68629 3 4 4.34315 4 6C4 7.65685 6.68629 9 10 9Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M4 11C4 12.6569 6.68629 14 10 14" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 16C4 17.6569 6.68629 19 10 19" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 6V16" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 6V8.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M15.9999 14.75C18.0391 14.75 19.6922 13.9105 19.6922 12.875C19.6922 11.8395 18.0391 11 15.9999 11C13.9607 11 12.3076 11.8395 12.3076 12.875C12.3076 13.9105 13.9607 14.75 15.9999 14.75Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.3076 16C12.3076 17.0355 13.9607 17.875 15.9999 17.875C18.0391 17.875 19.6922 17.0355 19.6922 16"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.3076 19.125C12.3076 20.1605 13.9607 21 15.9999 21C18.0391 21 19.6922 20.1605 19.6922 19.125"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M12.3076 12.875V19.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.6924 12.875V19.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
